import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../constants';

const SplashScreen = ({bannerData}) => {
    // const navigate = useNavigate();      
  const bannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/home_Bg.png)`,
  };
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    fade: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover:false
  };
  return (
    <div>
      <div className="wrapper">
        <div className="bannerArea">
        <div className="bannerBg_image">
          <img src={`${BASE_URL}/assets/images/home_Bg.png`} alt="" />
        </div>
          <div className="bannerContentPart">
            <div className="logo">
              <a href="#">
                <img src={`${BASE_URL}/assets/images/logo.png`} alt="" />
              </a>
            </div>
            <Slider {...sliderSettings} className="bannerSlider">
            {bannerData && bannerData.map((item) => (
              <li className="slide">
                <div className="slide__image">
                  <img src={item?.default_image} alt="" />
                </div>
                <div className="heading">
                  <h3 className="head oneHeading">
                    <span>
                      {item?.name}
                    </span>
                  </h3>
                </div>
              </li>
            ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
